// localize the requires here
/* eslint-disable @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports */
export const slackIcon: string = require("./slack.svg");
export const lightBulbIcon: string = require("./lightbulb.svg");
export const scheduleMeetingIcon: string = require("./schedule-meeting.svg");
/* eslint-enable @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports */

export { SparkleIcon } from "./SparkleIcon";
export { TwitterIcon } from "./TwitterIcon";
export * from "./check";
export { AdminPanelSettingsIcon } from "./AdminPanelSettingsIcon";
